import React, { FC, useCallback, useMemo } from "react";
import { Input, PasswordToggle, useToggle } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { isValidUrl } from "../../../../utils/isValidUrl";
import { ExtendedParameters } from "../../DialogComponents/ExtendedParameters/ExtendedParameters";
import { FieldsRow } from "../../DialogComponents/ResourceMeta/styled";
import { ResourceTypeItem } from "../../DialogComponents/ResourceType/types";
import { RestrictedWidthContainer } from "../../DialogComponents/styled";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { AddProxyServiceWizardStep } from "./AddProxyServiceWizardStep";
import { ProxyServiceURL } from "./ProxyServiceURL";
import { ProxyServiceType } from "./types";
import { ProxyServiceResourceType } from "./styled";

export const AddProxyServiceType: FC = () => {
  const { t } = useTranslation("dialogs");
  const { serviceType, setServiceType, sourceUrl, setSourceUrl, importLayers, subDomainsValue, setSubDomainsValue } =
    useAddProxyServiceContext();
  const [showPassword, toggleShowPassword] = useToggle(false);

  const proxyServiceTypes = useMemo(
    (): ResourceTypeItem[] => [
      {
        text: "WMS",
        icon: "wms_service",
        value: ProxyServiceType.WMS,
      },
      {
        text: `XYZ-${t("addProxyService.service")}`,
        icon: "tms",
        value: ProxyServiceType.TMS,
      },
      {
        text: "ArcGIS",
        icon: "arcgis_service",
        value: ProxyServiceType.ArcGIS,
      },
    ],
    [t],
  );

  const onNextStep = useCallback(() => {
    importLayers();
  }, [importLayers]);

  return (
    <AddProxyServiceWizardStep nextStepDisabled={!isValidUrl(sourceUrl)} onNextStep={onNextStep}>
      <ProxyServiceResourceType
        resourceTypes={proxyServiceTypes}
        selectedType={serviceType}
        onSelect={({ value }) => setServiceType(value as ProxyServiceType)}
      />
      <RestrictedWidthContainer>
        <ProxyServiceURL
          sourceUrl={sourceUrl}
          setSourceUrl={setSourceUrl}
          serviceType={serviceType}
          subDomainsValue={subDomainsValue}
          setSubDomainsValue={setSubDomainsValue}
        />
        <ExtendedParameters>
          <FieldsRow>
            <Input type="text" label={t("addProxyService.username")} width="100%" />
            <Input type={showPassword ? "text" : "password"} label={t("addProxyService.password")} width="100%">
              <PasswordToggle onClick={toggleShowPassword} isSelected={showPassword} />
            </Input>
          </FieldsRow>
        </ExtendedParameters>
      </RestrictedWidthContainer>
    </AddProxyServiceWizardStep>
  );
};
